import React, { useState, useReducer, useEffect } from "react"
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  FormControl,
  Grid,
  InputLabel,
  CircularProgress,
  MenuItem,
  Select,
  Alert,
} from "@mui/material"
import GridFiles from "components/Common/GridFilesAnt"
import FilePondUpload from "components/Common/FilePondUpload"
import { getCurrentUser, enumToArray } from "helpers/service_helper"
import { FileGasProjectTypeEng } from "models/types/file-gas-project-type-eng"

export const ProjectFiles = ({ rowData, mainProps }) => {
  const { lstGasProjectFiles, onGetProjectFiles } = mainProps
  const style = {
    // border: "2px solid #000",
    p: 2,
  }
  const [files, setFiles] = useState([])
  const [formInput, setFormInput] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      idGasProject: rowData.idGasProject,
      fileTypeEnum: 11,
    }
  )
  const [fileGasProjectTypes, setFileGasProjectTypes] = useState([])
  useEffect(() => {
    if (rowData.idGasProject)
      setFileGasProjectTypes(enumToArray(FileGasProjectTypeEng))
    onGetProjectFiles(rowData.idGasProject)
  }, [rowData.idGasProject])

  const handleInput = evt => {
    const name = evt.target.name
    const newValue = evt.target.value
    console.log(name, newValue)
    setFormInput({ [name]: newValue })
  }
  const saveToDatabase = async values => {
    const { onAddFileGasProjectSingle } = mainProps
    let file = files[0].file
    const fileName = FileGasProjectTypeEng[values.fileTypeEnum]
    let formData = new FormData()
    formData.append(
      "file",
      file,
      fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("gasProjectId", JSON.stringify([values.idGasProject]))
    formData.append("name", "gas-" + fileName)
    formData.append("des", `Upload with-${getCurrentUser().sid}`)
    formData.append("fileTypeEnum", fileName)
    formData.append("FolderName", "GasProjects")
    formData.append(
      "FileName",
      fileName + "." + file.name.split(".")[file.name.split(".").length - 1]
    )
    formData.append("userId", getCurrentUser().sid)
    formData.append("toUserId", getCurrentUser().sid)

    await onAddFileGasProjectSingle(formData)
  }
  const handleSubmitForm = async (event, values) => {
    event.preventDefault()

    if (formInput.idGasProject.length !== 0 && files[0]) {
      await saveToDatabase(formInput)
      // await onGetProjectFiles(formInput.idGasProject)
    } else {
      setErrorMessage("برای ذخیره ابتدا فایل را برگذاری کنید")
    }
  }
  return (
    <form onSubmit={handleSubmitForm}>
      <Grid item xs={12}>
        {mainProps.error ? (
          <Alert severity="error">{mainProps.error}</Alert>
        ) : null}
        {mainProps.success ? (
          <Alert severity="success">{mainProps.success}</Alert>
        ) : null}
      </Grid>
      {(rowData.projectLevel !== 2 || rowData.inspectionStatus <=1 ) && (
        <Box>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <FormControl size="small" fullWidth>
                <InputLabel id="select-label-fileTypeEnum">نوع فایل</InputLabel>
                <Select
                  labelId="select-label-fileTypeEnum"
                  name="fileTypeEnum"
                  value={formInput.fileTypeEnum ? formInput.fileTypeEnum : 2}
                  label="نوع فایل"
                  onChange={handleInput}
                >
                  {fileGasProjectTypes &&
                    fileGasProjectTypes.map(row => {
                      if (
                        row.id !== 0 &&
                        row.id !== 3 &&
                        row.id !== 5 &&
                        row.id !== 6 &&
                        row.id !== 12
                      ) {
                        return (
                          <MenuItem key={row.id} value={row.id}>
                            {mainProps.t("enums." + row.name)}
                          </MenuItem>
                        )
                      }
                    })}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12}>
              <FilePondUpload
                setFiles={setFiles}
                maxFileSize="800KB"
                allowMultiple={false}
                maxFiles={1}
                acceptedFileTypes={["image/png", "image/jpeg"]}
                imagePreviewMaxHeight={600}
                labelText={`${mainProps.t(
                  "enums." + FileGasProjectTypeEng[formInput.fileTypeEnum]
                )} را اینجا بکشید`}
                waterMark={false}
              />
            </Grid>
          </Grid>
        </Box>
      )}
      {rowData.gasProject.projectLevelEnum === 2 ? "نقشه تایید شده است" : ""}
      {!rowData.accepted?"\nپرونده در وضعیت قبول قرار ندارد، امکان بارگذاری فایل وجود ندارد.":""}
      {rowData.inspectionStatus >1 && "پرونده در وضعیت بازبینی قرار دارد، امکان بارگذاری فایل وجود ندارد."}
      {rowData.inspectionStatus <=1 && 
        <Box sx={{ display: "flex" }}>
        {mainProps.loadingGasProject ? (
          <CircularProgress disableShrink />
        ) : (
          <Button
            disabled={rowData.gasProject.projectLevelEnum === 2 ||!rowData.accepted ||!files[0]}
            variant="contained"
            type="submit"
          >
            ذخیره
          </Button>
        )}
      </Box>
      }
 
      <Box sx={{ ...style }}>
        <GridFiles lstGasProjectFiles={lstGasProjectFiles} props={mainProps} />
      </Box>
    </form>
  )
}
